import { createContext, useState, useContext, useEffect } from 'react'
import { isDate18orMoreYearsOld, years, months } from '@utils/dates'
import { parse } from 'date-fns';

const AgeVerificationContext = createContext();
const AgeVerificationProvider = ({ children }) => {
  // The actual values selected
  const [ageValue, setAgeValue] = useState({
    year: years[2],
    month: Intl.DateTimeFormat('en-US', { month: 'long' }).format(new Date(`${new Date().getYear()}/3/1`)),
    day: 3,
  })
  // The possible values that can be selected
  const [ageSelections, setAgeSelections] = useState({
    year: years,
    month: months,
    day: [...Array.from({ length: 31 }, (_, i) => i + 1)],
  })
  // Set to true when the user is determined to be 18 years or older
  const [meetsCriteria, setMeetsCriteria] = useState(false)
  // Set true when the user has confirmed their age and accepted terms
  const [acceptedTerms, setAcceptedTerms] = useState(false)

  // Update days on the picker to the curren month
  useEffect(() => {
    const parsedMonth = parse(`${ageValue.year} ${ageValue.month} 1`, 'yyyy MMMM d', new Date()).getMonth()
    const daysOfMonth = new Date(ageValue.year, parsedMonth + 1, 0).getDate()
    const newDays = [...Array.from({ length: daysOfMonth }, (_, i) => i + 1)]
    setAgeSelections({
      ...ageSelections,
      day: newDays,
    })
    // check if selected day is greater than the number of days in the month and change accordingly
    if (ageValue.day > newDays[newDays.length - 1]) {
      setAgeValue({ ...ageValue, day: newDays[newDays.length - 1] })
    }
  }, [ageValue?.month, ageValue?.year])

  // Detect if the user is 18 years or older
  useEffect(() => {
    const parsedMonth = parse(`${ageValue.year} ${ageValue.month} 1`, 'yyyy MMMM d', new Date()).getMonth()
    // WARNING: DateFns 'M'  parsing starts at 1, not 0 like js date objects
    if (isDate18orMoreYearsOld(ageValue.day, parsedMonth + 1, ageValue.year)) {
      setMeetsCriteria(true)
    } else {
      setAcceptedTerms(false)
      setMeetsCriteria(false)
    }
  }, [ageValue])

  return (
    <AgeVerificationContext.Provider
      value={{
        setAcceptedTerms,
        acceptedTerms,
        setAgeSelections,
        ageSelections,
        setAgeValue,
        ageValue,
        meetsCriteria,
      }}>
      {children}
    </AgeVerificationContext.Provider>
  )
}

const useAgeVerificationContext = () => useContext(AgeVerificationContext)

export default useAgeVerificationContext

export { AgeVerificationContext, AgeVerificationProvider, useAgeVerificationContext }
